export const EarnPercent = {
  sellOwnerEarnPercent: 0.8,
};


export default {
  EarnPercent,
};
